{
  "SEARCH": {
    "TABS": {
      "ALL": "كل النتائج",
      "CONTACTS": "جهات الاتصال",
      "CONVERSATIONS": "المحادثات",
      "MESSAGES": "الرسائل",
      "ARTICLES": "Articles"
    },
    "SECTION": {
      "CONTACTS": "جهات الاتصال",
      "CONVERSATIONS": "المحادثات",
      "MESSAGES": "الرسائل",
      "ARTICLES": "Articles"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "جاري البحث",
    "LOADING_DATA": "جار التحميل",
    "EMPTY_STATE": "لم يتم العثور على {item} للطلب '{query}'",
    "EMPTY_STATE_FULL": "لم يتم العثور على نتائج للطلب '{query}'",
    "PLACEHOLDER_KEYBINDING": "/للتركيز",
    "INPUT_PLACEHOLDER": "أكتب 3 أحرف أو أكثر للبحث",
    "RECENT_SEARCHES": "عمليات البحث الأخيرة",
    "CLEAR_ALL": "Clear all",
    "MOST_RECENT": "الأحدث",
    "EMPTY_STATE_DEFAULT": "البحث عن طريق معرف المحادثة أو البريد الإلكتروني أو رقم الهاتف أو الرسائل للحصول على نتائج بحث أفضل. ",
    "BOT_LABEL": "رد آلي",
    "READ_MORE": "اقرأ المزيد",
    "READ_LESS": "قراءة أقل",
    "WROTE": "كتب:",
    "FROM": "من",
    "EMAIL": "البريد الإلكتروني",
    "EMAIL_SUBJECT": "الموضوع",
    "PRIVATE": "ملاحظة خاصة",
    "TRANSCRIPT": "النص",
    "CREATED_AT": "created {time}",
    "UPDATED_AT": "تم التحديث {time}",
    "SORT_BY": {
      "RELEVANCE": "ذات صلة"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "آخر 7 أيام",
      "LAST_30_DAYS": "آخر 30 يوماً",
      "LAST_60_DAYS": "آخر 60 يوماً",
      "LAST_90_DAYS": "آخر 90 يوماً",
      "CUSTOM_RANGE": "نطاق مخصص:",
      "CREATED_BETWEEN": "تم الإنشاء بين",
      "AND": "و",
      "APPLY": "تطبيق",
      "BEFORE_DATE": "قبل {date}",
      "AFTER_DATE": "بعد {date}",
      "TIME_RANGE": "التصفية حسب الوقت",
      "CLEAR_FILTER": "مسح عامل التصفية"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "تصفية الرسائل بواسطة:",
      "FROM": "المرسل",
      "IN": "صندوق الوارد",
      "AGENTS": "الوكلاء",
      "CONTACTS": "جهات الاتصال",
      "INBOXES": "قنوات التواصل",
      "NO_AGENTS": "لم يتم العثور على وكلاء",
      "NO_CONTACTS": "ابدأ بالبحث لمشاهدة النتائج",
      "NO_INBOXES": "لم يتم العثور على صناديق الوارد"
    }
  }
}
